import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MyLandbot from "./MyLandbot";
import { listBotDetails } from "../actions/botActions";
import DashHeader from "./DashHeader";
import { Helmet } from "react-helmet-async";
import { MendableInPlace } from "@mendable/search"

function MendableBot() {
  

  // Set up dispatch and params hooks
  const dispatch = useDispatch();
  // let param = useParams();


// Query bot details from db and pass to redux
  useEffect(() => {
    dispatch(listBotDetails(3));
    }, [dispatch]);
  // Get bot details from global state
  const botDetails = useSelector((state) => state.botDetails);
  const { bot } = botDetails;
  const url = bot?.link;

  // Get user details from global state
  const { userInfo } = useSelector((state) => state.userLogin);
  let id;
  if (userInfo){
    const { id } = userInfo;
  }

  const style = { darkMode: false, accentColor: "#f19601" }

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
      <title>Feedback Portal</title>
        <meta name="description" content="We are constantly getting better with your help. Please provide us some feedback on your experiance, our technology and much more."/>
        <link rel="canonical" href="/dashboard/feedback"/>
      </Helmet>
      <DashHeader pageTitle={"Feedback Portal"} />
      {/* {userInfo ? (
      <Row className="dashboard-content-container">
        {url ? <MyLandbot url={url} userId={id} /> : ""}
      </Row>):(
        <Row className="dashboard-content-container">
        {url ? <MyLandbot url={url}/> : ""}
      </Row>
      )} */}
      <Row><MendableInPlace anon_key='d4b825c7-d2b3-431a-b007-058372a83222' style={style} welcomeMessage={"Let me help you help yourself"} /></Row>
    </Col>
  );
}

export default MendableBot;
